module.exports = __webpack_public_path__ + "media/images/icons/justify-left-922d93d6182e295d0c8904eae4d2fde2.svg";